import React from 'react';
import { useIntl } from 'umi';

interface ISummaryCardsProps {
  cubeNameSummary: string;
  tablesSummary: string;
  dimCount: number;
  measCount: number;
}

/**
 * Step4 顶部：Cube / 数据源表 / 维度 / 指标摘要卡片。
 */
const SummaryCards: React.FC<ISummaryCardsProps> = ({
  cubeNameSummary,
  tablesSummary,
  dimCount,
  measCount,
}) => {
  const { formatMessage } = useIntl();
  const dimSummary = formatMessage(
    { id: 'dbl_model_agent_summary_count_unit' },
    { n: dimCount },
  );
  const measSummary = formatMessage(
    { id: 'dbl_model_agent_summary_count_unit' },
    { n: measCount },
  );

  return (
    <div className="dbl-model-agent-create-card-list">
      <div className="dbl-model-agent-create-card">
        <div className="dbl-model-agent-create-card-title">
          {formatMessage({ id: 'dbl_model_agent_step4_summary_cube_name' })}
        </div>
        <div className="dbl-model-agent-create-card-content">
          {cubeNameSummary}
        </div>
      </div>
      <div className="dbl-model-agent-create-card">
        <div className="dbl-model-agent-create-card-title">
          {formatMessage({ id: 'dbl_model_agent_step4_summary_source_table' })}
        </div>
        <div className="dbl-model-agent-create-card-content">
          {tablesSummary}
        </div>
      </div>
      <div className="dbl-model-agent-create-card">
        <div className="dbl-model-agent-create-card-title">
          {formatMessage({ id: 'dbl_model_agent_step4_summary_dim_fields' })}
        </div>
        <div className="dbl-model-agent-create-card-content">
          {dimSummary}
        </div>
      </div>
      <div className="dbl-model-agent-create-card">
        <div className="dbl-model-agent-create-card-title">
          {formatMessage({ id: 'dbl_model_agent_step4_summary_meas_fields' })}
        </div>
        <div className="dbl-model-agent-create-card-content">
          {measSummary}
        </div>
      </div>
    </div>
  );
};

export default SummaryCards;
